<template>
    <div class="card rounded-c-3 shadow border-0">
        <form @submit.prevent="register">
            <div class="card-body px-c-5 pt-4 pb-5">
                <div class="form-group mt-4 mb-2">
                    <label for="name" class="form-label"
                        >{{ localise("tour_form", "name")
                        }}<span class="text-danger ms-1">*</span></label
                    >
                    <input
                        id="name"
                        name="name"
                        type="text"
                        class="form-control py-3 rounded-c-3"
                        :class="v$.name.$error ? 'is-invalid' : ''"
                        :placeholder="localise('tour_form', 'name_placeholder')"
                        v-model="name"
                    />
                    <div v-if="v$.name.minLength" class="invalid-feedback">
                        {{ localise("validation", "min5") }}
                    </div>
                </div>
                <div class="form-group mt-4 mb-2">
                    <label for="phone" class="form-label"
                        >{{ localise("tour_form", "phone")
                        }}<span class="text-danger ms-1">*</span></label
                    >
                    <input
                        id="phone"
                        name="phone"
                        type="number"
                        class="form-control py-3 rounded-c-3"
                        :class="v$.phone.$error ? 'is-invalid' : ''"
                        :placeholder="
                            localise('tour_form', 'phone_placeholder')
                        "
                        v-model="phone"
                    />
                    <div v-if="v$.phone.$error" class="invalid-feedback">
                        {{ localise("validation", "phone") }}
                    </div>
                </div>
                <div class="form-group mt-4 mb-2">
                    <label for="email" class="form-label"
                        >{{ localise("tour_form", "email")
                        }}<span class="text-secondary ms-1"
                            ><small>(არაა აუცილებელი)</small></span
                        ></label
                    >
                    <input
                        id="email"
                        name="email"
                        type="text"
                        class="form-control py-3 rounded-c-3"
                        :class="v$.email.$error ? 'is-invalid' : ''"
                        :placeholder="
                            localise('tour_form', 'email_placeholder')
                        "
                        v-model="email"
                    />
                    <div v-if="v$.email.$error" class="invalid-feedback">
                        {{ localise("validation", "email") }}
                    </div>
                </div>
                <div class="form-group mt-4 mb-2">
                    <label for="products" class="form-label"
                        >{{ localise("tour_form", "products")
                        }}<span class="text-secondary ms-1"
                            ><small>(არაა აუცილებელი)</small></span
                        ></label
                    >
                    <textarea
                        id="products"
                        name="products"
                        cols="10"
                        rows="3"
                        class="form-control py-3 rounded-c-3"
                        :class="v$.products.$error ? 'is-invalid' : ''"
                        v-model="products"
                    ></textarea>
                    <div v-if="v$.products.$error" class="invalid-feedback">
                        {{ localise("validation", "products") }}
                    </div>
                </div>
                <div class="text-center mt-3">
                    <button
                        type="submit"
                        class="btn btn-lg btn-c-secondary rounded-c-3 px-5 py-4 fs-6 text-white shadow mt-4 w-100"
                        :disabled="$store.state.loading"
                    >
                        <div
                            v-if="$store.state.loading"
                            class="spinner-grow spinner-grow-sm text-dark ms-1"
                            role="status"
                        >
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <span v-else>
                            {{ localise("tour_form", "button") }}
                            <i class="fas fa-check-circle ms-1"></i>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import translations from "../../helpers/translations";
import useVuelidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";
import { summerFestRegistration } from "../../services/InternalApiService";

export default {
    name: "SummerFestRegistrationForm",
    setup() {
        return {
            v$: useVuelidate(),
        };
    },
    data() {
        return {
            name: "",
            email: "",
            phone: "",
            products: "",
        };
    },
    validations() {
        return {
            name: {
                required,
                minLength: minLength(5),
            },
            phone: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            email: {
                minLength: minLength(0),
            },
            products: {
                minLength: minLength(0),
            },
        };
    },
    methods: {
        register() {
            this.v$.$validate();
            this.v$.$touch();
            if (!this.v$.$invalid) {
                this.$store.state.loading = true;
                setTimeout(() => {
                    summerFestRegistration({
                        full_name: this.name,
                        email: this.email,
                        phone: this.phone,
                        products: this.products,
                    })
                        .then((res) => {
                            this.$store.state.loading = false;
                            if (res.data.success) {
                                this.clearInputs();
                                this.v$.$reset();
                                Swal.fire({
                                    position: "center",
                                    icon: "success",
                                    title: this.localise(
                                        "tour_form",
                                        "success_message"
                                    ),
                                    text: res.data.message,
                                    showConfirmButton: true,
                                    confirmButtonText: this.localise(
                                        "tour_form",
                                        "confirm_button"
                                    ),
                                });
                            } else {
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: this.localise("validation", "error"),
                                    showConfirmButton: false,
                                    timer: 1500,
                                });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            Swal.fire({
                                position: "center",
                                icon: "error",
                                title: this.localise("validation", "error"),
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            setTimeout(() => {
                                this.$store.state.loading = false;
                            }, 1500);
                        });
                }, 0);
            } else {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: this.localise("validation", "error"),
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },
        clearInputs() {
            this.name = "";
            this.email = "";
            this.phone = "";
            this.products = "";
        },
        localise(cat, key) {
            return translations[this.$store.state.locale][cat][key];
        },
    },
};
</script>
